import { render } from "./ExpensesCreateNew.vue?vue&type=template&id=cbb0034e"
import script from "./ExpensesCreateNew.vue?vue&type=script&lang=js"
export * from "./ExpensesCreateNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__